import { AddPaymentMethod as AddPaymentMethodShared } from '../../../../components/Containers/ReviewCheckoutDrawer/PaymentMethod/AddPaymentMethod';
import { useFlow } from '../../../../providers';
import { usePreAuthOfferCtx } from '../../../../providers/PreAuthOfferProvider';

export const AddPaymentMethod = () => {
  const {
    billingAddress,
    error,
    isBillingSameAsShipping,
    setBillingAddress,
    setIsBillingSameAsShipping,
    setIsNewPaymentMethod,
  } = usePreAuthOfferCtx();
  const { goToStep } = useFlow();

  return (
    <AddPaymentMethodShared
      billingAddress={billingAddress}
      error={error}
      isBillingSameAsShipping={isBillingSameAsShipping}
      onSave={() => {
        setIsNewPaymentMethod(true);
        goToStep('review');
      }}
      setBillingAddress={setBillingAddress}
      setIsBillingSameAsShipping={setIsBillingSameAsShipping}
    />
  );
};
